import { RootState } from "../../types/redux-types";

export const selectSelectedRowIndex = (state: RootState) =>
  state.collectionTable.selectedRowIndex;
